<div [attr.dir]="translate.currentLang == 'ar' ? 'rtl' : 'ltr'">
  <div mat-dialog-title class="modal-header-bg d-flex justify-content-end px-3 pt-1"></div>
  <div mat-dialog-content [attr.dir]="translate.currentLang == 'ar' ? 'rtl' : 'ltr'">
    <h4 class="font-weight-bold title-text text-start">
      {{ "deposit-modal-title" | translate }}
      <img src="assets/img/Deposit.svg" alt="Deposit" class="withdraw-icon">
    </h4>
    <p class="text-muted-special subtitle-text text-start">{{ "deposit-modal-subtitle" | translate }}</p>

    <form #depositForm="ngForm">
      <mat-horizontal-stepper class="responsive-stepper deposit-stepper-height"
      [linear]="true" #stepper
      [disableRipple]="true">
        <mat-step [label]="'choose-deposit-method' | translate"  [completed]="selectedBank && selectedCurrency">
          <small class="text-muted-special">
            {{ "deposit-instructions" | translate }}
          </small>

          <div class="d-flex justify-content-between mt-3 col-md-4">
            <div *ngFor="let option of options" class="checkbox-container" [class.selected-checkBox]="selectedMethod === option.id" (click)="selectOption(option.id)">
              <div class="checkbox-wrapper">
                <input class="mx-2" type="radio" [id]="option.id" [checked]="selectedMethod === option.id" (click)="($event.stopPropagation())" (change)="selectOption(option.id)" />
                <label (click)="($event.stopPropagation())" class="checkBox-label" [for]="option.id">{{ option.label | translate }}</label>
              </div>
            </div>
          </div>

          <div class="row" *ngIf="depositMethod === 'bank-transfer'">
            <div class="container mt-2">
              <div class="row">               
                <div class="col-md-4 mb-3">
                  <label class="required text-color-theme">{{ 'currency' | translate }}</label>
                  <ng-select [searchable]="true" [dropdownPosition]="'bottom'" (change)="onCurrencyChange($event)" [searchable]="false" class="custom" name="currency" [(ngModel)]="selectedCurrency" required>
                    <ng-option *ngFor="let curr of currencyList" [value]="curr">
                      {{ translate.currentLang == 'en' ? curr.CurrencyNameE : curr.CurrencyNameA }}
                    </ng-option>
                  </ng-select>
                </div>
            <div class="col-md-4 mb-3">
              <label class="required text-color-theme">{{
                "deposit-bank" | translate
              }}</label>
              <ng-select
              [(ngModel)]="selectedBank"
                [clearable]="false"
                name="depositBank"
                #depositBank="ngModel"
                class="custom"
                ngModel
                
                (change)="GetBranches($event)"
                
              >
                <ng-option *ngFor="let bank of banksList" [value]="bank">
                  {{
                    translate.currentLang == "en"
                      ? bank.BankNameE
                      : bank.BankNameA
                  }}
                </ng-option>
              </ng-select>
            </div>
            <div class="col-md-4 mb-3">
              <label class="required text-color-theme">{{
                "bank-branch" | translate
              }}</label>
              <ng-select
              [(ngModel)]="selectedBranch"
                [clearable]="false"
                name="bankBranch"
                #bankBranch="ngModel"
                class="custom"
                ngModel
                
              >
                <ng-option *ngFor="let branch of branches" [value]="branch">
                  {{
                    translate.currentLang == "en"
                      ? branch.BankNameE
                      : branch.BankNameA
                  }}
                </ng-option>
              </ng-select>
            </div>

              </div>
            </div>
          </div>
          <div>
            <button class="next-btn-first" mat-button matStepperNext>{{ "Next" | translate }}</button>
          </div>
        </mat-step>

        <mat-step [label]="'bank-transfer-details' | translate">
          <small class="text-muted-special">{{ "bank-transfer-details" | translate }}</small>
          <div class="account-details mt-3">
            <div class="d-flex flex-column flex-xl-row flex-lg-row flex-md-row flex-sm-row">
              <span class="label">{{ "account-number" | translate }}</span>
              <div class="value">
                <span id="account-number" class="text-color-theme">{{ accountNumber }}</span>
                <div class="copy-icon" title="Copy" (click)="copyText('account-number')"></div>
              </div>
            </div>
            <div class="d-flex flex-column flex-xl-row flex-lg-row flex-md-row flex-sm-row">
              <span class="label">{{ "iban" | translate }}</span>
              <div class="value">
                <span id="iban" class="text-color-theme">{{ iBAN }}</span>
                <div class="copy-icon" title="Copy" (click)="copyText('iban')"></div>
              </div>
            </div>
            <div *ngIf="swiftcode">
              <span class="label">{{ "swift-code" | translate }}</span>
              <div class="value">
                <span id="swift-code" class="text-color-theme">{{ swiftcode }}</span>
                <div class="copy-icon" title="Copy" (click)="copyText('swift-code')"></div>
              </div>
            </div>
          </div>
          <div>
            <button class="next-btn" mat-button matStepperNext>{{ "Next" | translate }}</button>
          </div>
        </mat-step>
        <mat-step [completed]="cashAmount && cashAmount>0 && Date && fileToUpload" label="Enter Cash Amount" [label]="'enter-cash-amount' | translate">
          <div class="row">
            <div class="col-md-6 mt-3">
              <label class="required form-field-title">{{ "enter-amount" | translate }}</label>
              <div class="input-group">
                <input autocomplete="off"
                autocorrect="off"
                spellcheck="false"
                 (input)="formatCashInput($event)"

   pattern="^\d+(\.\d{1,2})?$" [formControl]="cashControl" maxlength="15" name="cash"  type="text" [placeholder]="'enter-cash-amount' | translate" class="form-control" />
                <div [ngClass]="{'input-group-append': translate.currentLang == 'en', 'input-group-prepend': translate.currentLang != 'en'}">
                  <span class="input-group-text currency">
                    {{ translate.currentLang == 'en' ? (selectedCurrency?.AbbreviationE || 'EGP') : (selectedCurrency?.AbbreviationA || 'EGP') }}
                  </span>
                </div>
              </div>
            </div>
            <div class="col-md-6 mt-3">
              <label class="required form-field-title">{{ "select-date" | translate }}</label>
              <div>
                <input [min]="today" 
                class="form-control" 
                #date="ngModel" id="date" 
                matInput 
                name="Date" 
                [(ngModel)]="Date" 
                readonly="true" 
                [placeholder]="'select-date' | translate" />
              </div>
            </div>
          </div>
          <div class="row mt-3 mx-0">
            <div class="attachment-wrapper col-md-12">
              <div class="d-flex flex-xl-row flex-lg-row flex-md-row flex-sm-row flex-column  justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                  <label class="attachment-label mb-0">
                    <span>{{ "add-attachment" | translate }}</span>
                    <button (click)="fileInput.click()" class="browse-btn">
                      {{ "browse" | translate }}
                      <input hidden #fileInput type="file" accept=".pdf, .doc, docx, image/jpeg, image/jpg, image/png" (change)="importFile($event.target.files)" />
                    </button>
                  </label>
                </div>
                <div class="file-list flex-grow-1 ml-3">
                  <div class="file-item d-flex align-items-center" *ngFor="let file of uploadedFiles; let i = index">
                    <img src="assets/img/pdf-icon.png" alt="PDF Icon" class="file-icon" />
                    <span class="text-wrap file-name ml-2">{{ file.name }}</span>
                    <button class="remove-btn ml-auto" (click)="removeFile(i)">✖</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <button
            class="confirm-deposit text-light mt-3"
            mat-button
            matStepperNext
            type="submit"
            [disabled]="
            depositForm.invalid ||
            !selectedAccount ||
            !cashAmount || cashAmount <= 0 ||
            !Date ||
            !fileToUpload"
            (click)="summary(cashAmount)"
          >
            {{ "submit" | translate }}
          </button>          </div>

        </mat-step>
<!-- 
        <mat-step [label]="'select-account-for-deposit' | translate">
          <small class="text-muted-special">{{ "select-account-details" | translate }}</small>

          <div class="accounts mb-3">
            <div class="account" *ngFor="let Acc of userAccounts" (click)="onAccountChange(Acc.relationCode)">
              <mat-checkbox 
                [checked]="isSelected(Acc.relationCode)">
              </mat-checkbox>
              
              <div class="account-details">
                <div class="account-name">
                  {{ translate.currentLang == "en" ? Acc.clientNameEn : Acc.clientNameAr }}
                </div>
                
                <div class="account-info">
                  <div class="account-type">
                    <span [ngClass]="getAccountClass(Acc.accountTypeEn)">
                      {{ translate.currentLang == "en" ? Acc.accountTypeEn : Acc.accountTypeAr }}
                    </span>
                  </div>
                  
                  <div class="account-id">
                    [{{ Acc.relationCode }}]
                  </div>
                </div>
              </div>
            </div>
          </div>
          


          <button class="confirm-deposit" mat-button matStepperNext type="submit" [disabled]="depositForm.invalid || !selectedAccount" (click)="summary(cashAmount)">{{ "submit" | translate }}</button>
        </mat-step> -->
      </mat-horizontal-stepper>
    </form>
  </div>
</div>
<ngx-loading
  [show]="isSubmitting"
  [config]="{ backdropBorderRadius: '3px' }"
></ngx-loading>